import React from 'react';
import './sass/Delivery.scss';

const Delivery = () => {
  return (
    <div className="delivery-content">
      <h3>배송/교환/반품</h3>
      <div className="delivery-list">
        <div className="delivery-item">
          <h4>교환배송비</h4>
          <ul>
            <li>
              - 상품의 배송비는 공급업체의 정책에 따라 다르오며 공휴일 및 휴일은 배송이 불가합니다.
            </li>
            <li>- 상품별로 상품 특성 및 배송지에 따라 배송유형 및 소요기간이 달라집니다.</li>
            <li>- 동일 브랜드의 상품이라도 상품별 출고일시가 달라 각각 배송될 수 있습니다.</li>
            <li>
              - 일부 주문상품 또는 예약상품의 경우 기본 배송일 외에 추가 배송 소요일이 발생될 수
              있습니다.
              <span>도서 산간 지역은 별도의 배송비와 반품비가 추가될 수 있습니다.</span>
            </li>
          </ul>
        </div>
        <div className="delivery-item">
          <h4>반품배송비</h4>
          <ul>
            <li>전체 반품 시 : 5,000원</li>
            <li>부분 반품 시 : 2,500원 (단, 부분 반품 후 결제금액이 3만원 미만인 경우 5,000원)</li>
            <li>*반품비는 브랜드/입점사별로 상이할 수 있습니다.</li>
            <li>*도서산간 지역은 추가 배송비가 부과됩니다.</li>
          </ul>
        </div>
        <div className="delivery-item">
          <h4>교환배송비</h4>
          <ul>
            <li>5,000원 (교환상품 배송비 +2,500원)</li>
            <li>*교환배송비는 브랜드/입점사별로 상이할 수 있습니다.</li>
          </ul>
        </div>
        <div className="delivery-item">
          <h4>교환/반품 유의사항</h4>
          <ul>
            <li>- 교환/반품은 배송완료 후 7일 이내 신청 가능합니다.</li>
            <li>
              - 상품하자 이외 사이즈, 색상교환 등 단순 변심에 의한 교환/반품 택배비 고객부담으로
              왕복택배비가 발생합니다.
            </li>
            <li>- 고객 부주의로 상품이 훼손, 변경된 경우 반품 / 교환이 불가능 합니다.</li>
            <li>
              - 주문완료 후 재고 부족 등으로 인해 주문 취소 처리가 될 수도 있는 점 양해
              부탁드립니다.
            </li>
            <li>
              - 임의반품은 불가하오니 반드시 고객센터나 MY Page & 주문취소/교환/반품 신청을 통해서
              신청접수를 하시기 바랍니다.
            </li>
            <li>- 특정브랜드의 상품설명에 별도로 기입된 교환/반품/AS기준이 우선합니다.</li>
          </ul>
        </div>
        <div className="delivery-item">
          <h4>교환안내</h4>
          <ul>
            <li>교환 가능 기간</li>
            <li>- 교환 신청은 배송 완료 후 7일 내 가능합니다.</li>
            <li>교환 불가 상품</li>
            <li>
              - 단순 변심의 경우 최초 배송된 상품의 상태와 다를 시 (세탁 또는 착용 후 외출하신 경우)
              교환 및 반품이 불가합니다.
            </li>
            <li>- 쥬얼리와 언더웨어 상품은 착용 이후 교환 및 반품이 불가합니다.</li>
            <li>- 맞춤제작의 경우 제작이 시작된 이후에는 취소,교환 및 반품이 불가합니다.</li>
          </ul>
        </div>
        <div className="delivery-item">
          <h4>반품안내</h4>
          <ul>
            <li>반품 가능 기간</li>
            <li>- 반품 신청은 배송 완료 후 7일 내 가능합니다.</li>
            <li>반품 불가 상품</li>
            <li>
              - 단순 변심의 경우 최초 배송된 상품의 상태와 다를 시 (세탁 또는 착용 후 외출하신 경우)
              교환 및 반품이 불가합니다.
            </li>
            <li>- 쥬얼리와 언더웨어 상품은 착용 이후, 교환 및 반품이 불가합니다.</li>
            <li>- 맞춤제작의 경우 제작이 시작된 이후에는 취소,교환 및 반품이 불가합니다.</li>
            <li>
              - 상품박스, 별도 부속물등이 정상적인 상태에서 반품진행이 원활하게 진행될 수 있습니다.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Delivery;
